import * as actionTypes from "./OpportunityType";

const INITIAL_STATE = {
    filterCustomerList: [],
    filterStageList: [],
    filterEmpList: [],
    opportunityList: [],
    followupHistoryList: [],
    verticalList: [],
    sourceList: [],
    customerList: [],
    opportunity: null,
    attachmentList: [],
    advanceFilterList: [],
    customerDetails: null,
    statusList: [],
    addStateList: [],
    taskList: [],
    basicFilterData: []
};

const OpportunityReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETFILTERCUSTOMERLIST:
            return {
                ...state,
                filterCustomerList: action.payload.list,
            };
        case actionTypes.SETFILTEROPPSTAGE:
            return {
                ...state,
                filterStageList: action.payload.list,
            };
        case actionTypes.SETFILTEREMPRESP:
            return {
                ...state,
                filterEmpList: action.payload.list,
            };
        case actionTypes.SETOPPLIST:
            return {
                ...state,
                opportunityList: action.payload.list,
            };
        case actionTypes.SETFOLLOWUPHISTORYLIST:
            return {
                ...state,
                followupHistoryList: action.payload.list,
            };
        case actionTypes.SETVERTICALLIST:
            return {
                ...state,
                verticalList: action.payload.list,
            };
        case actionTypes.SETSOURCELIST:
            return {
                ...state,
                sourceList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERLIST:
            return {
                ...state,
                customerList: action.payload.list,
            };
        case actionTypes.SETOPPORTUNITY:
            return {
                ...state,
                opportunity: action.payload,
            };
        case actionTypes.SETATTACHMENTLIST:
            return {
                ...state,
                attachmentList: action.payload.list,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                attachmentList: [],
                opportunity: null,
                customerDetails: null
            };
        case actionTypes.SETADVANCEFILTERLIST:
            return {
                ...state,
                advanceFilterList: action.payload.list
            };
        case actionTypes.SETCUSTOMERDETAILS:
            return {
                ...state,
                customerDetails: action.payload.data
            };
        case actionTypes.SETSTATUSLIST:
            return {
                ...state,
                statusList: action.payload.list
            };
        case actionTypes.SETADDITIONALSTATELIST:
            return {
                ...state,
                addStateList: action.payload.list
            };
        case actionTypes.SETTASKLIST:
            return {
                ...state,
                taskList: action.payload.list
            };
        case actionTypes.SETOPPORTUNITYBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default OpportunityReducer;